// src/components/store/sections/testimonials/TestimonialV71CardsliderLimeZest.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV71CardsliderLimeZest(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={71}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
